'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { faTriangleExclamation as m, faCircleInfo as g } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import n from "../../external/classnames/index.js";
import { useTheme as j } from "../Provider/index.js";
const b = ({
  title: d = "Score",
  items: t = [],
  score: r = -1,
  disclaimer: x,
  className: o
}) => {
  const { isMosh: c, isMoshy: f } = j(), { explanation: i, explanationVariant: l } = t.find(
    ({ scoreMin: s, scoreMax: a }) => r >= s && r <= a
  ) || {};
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: n(
        o,
        "flex flex-col gap-6 rounded-2xl border border-grey-200 bg-white p-4 shadow-md w-full"
      ),
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row gap-6", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center gap-2 rounded-lg bg-green-faint-dark p-4 text-white md:flex-1", children: [
            /* @__PURE__ */ e.jsx("small", { children: d }),
            /* @__PURE__ */ e.jsx("h1", { children: r === -1 ? "-" : r })
          ] }),
          /* @__PURE__ */ e.jsx("table", { className: "flex-1", children: /* @__PURE__ */ e.jsxs("tbody", { className: "flex flex-col justify-center gap-2", children: [
            /* @__PURE__ */ e.jsxs("tr", { className: "flex flex-row justify-between", children: [
              /* @__PURE__ */ e.jsx("th", { className: "font-demi text-xs text-grey-400", children: "Score range" }),
              /* @__PURE__ */ e.jsx("th", { className: "font-demi text-xs text-grey-400", children: "Severity" })
            ] }),
            t.map((s, a) => /* @__PURE__ */ e.jsxs(
              "tr",
              {
                className: n(
                  "flex flex-row justify-between",
                  {
                    "font-demi text-green": r >= s.scoreMin && r <= s.scoreMax
                  }
                ),
                children: [
                  /* @__PURE__ */ e.jsx("td", { children: s.scoreText }),
                  /* @__PURE__ */ e.jsx("td", { children: s.severity })
                ]
              },
              a
            ))
          ] }) })
        ] }),
        r > -1 && i ? /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: `flex flex-row gap-2 rounded-lg p-4 ${l === "warning" ? "bg-yellow-dark" : "bg-green-light"}`,
            children: [
              /* @__PURE__ */ e.jsxs(
                "div",
                {
                  className: `flex flex-1 flex-col gap-2 ${l === "warning" ? "text-orange-dark" : ""}`,
                  children: [
                    /* @__PURE__ */ e.jsx("h4", { children: "What this means" }),
                    /* @__PURE__ */ e.jsx("p", { children: i }),
                    x ? /* @__PURE__ */ e.jsx(
                      "p",
                      {
                        className: n("p2 mb-0", {
                          "text-orange-dark": l === "warning",
                          "text-green-faint-dark": c && !l,
                          "text-grey-400": f && !l
                        }),
                        children: x
                      }
                    ) : null
                  ]
                }
              ),
              /* @__PURE__ */ e.jsx(
                h,
                {
                  icon: l === "warning" ? m : g,
                  size: "xl",
                  className: l === "warning" ? "text-orange-dark" : "text-green-faint-dark"
                }
              )
            ]
          }
        ) : null
      ]
    }
  );
};
export {
  b as default
};
